<template>
  <nav :class="custom_class">
    <div class="container">
      <div class="navbar-translate">
        <router-link v-if="showLogo" to="/">
          <img class="logo mr-auto" href="#" src="@/assets/images/Bigger_Logo_01.png" alt />
        </router-link>
        <button class="navbar-toggler navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation"
          aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <div class="collapse navbar-collapse justify-content-end" id="navigation">
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link to="/jobs" class="nav-link">Jobs</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  let resizeTimeout;
  function resizeThrottler(actualResizeHandler) {
    if(!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        resizeTimeout = null;
        actualResizeHandler();
      }, 66);
    }
  }

  export default {
    name: "Navbar",
    props: {
      transparent: {
        type: Boolean,
        default: false
      },
      logo: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        extraClass: '',
        colorOnScroll: 300,
        showNavbar: false,
        showLogo: false
      }
    },
    computed: {
      custom_class() {
        var c = "navbar navbar-expand-lg fixed-top " + this.extraClass;
        if(this.transparent) {
          if(!this.showNavbar){
            c += " navbar-transparent";
          }
        }
        this.showLogo = this.$props.logo || this.showNavbar;
        return c;
      }
    },
    methods: {
      handleScroll() {
        let scrollValue =
          document.body.scrollTop || document.documentElement.scrollTop;
        this.currentScrollValue = scrollValue;
        var check = this.colorOnScroll > 0 && scrollValue > this.colorOnScroll;
        this.showNavbar = check;
        // if (check) {
        //   this.extraClass = `bg-${this.type}`;
        //   console.log("bg-asd")
        // } else {
        //   if (this.extraClass) {
        //     this.extraClass = ''
        //   }
        // }
      },
      scrollListener() {
        resizeThrottler(this.handleScroll);
      }
    },
    mounted() {
      document.addEventListener('scroll', this.scrollListener);
    },
    beforeDestroy() {
      document.removeEventListener('scroll', this.scrollListener);
    }
  }
</script>



<style lang="scss" scoped>

  .logo {
    width: 64px;
    margin: 16px;
  }
  .nav-item {
    .nav-link {
      color : #66615B!important;
      font-size: 16px!important;
    }
  }

  .navbar-transparent {
    .nav-link {
      color : white!important;
    }
  }
  

</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue